import type { ErrorResponseInterceptor, ResponseInterceptor } from '..';
import { ApiHelper } from '..';
import { errorToMessage } from './errors/error-messages';
import log from './log';
import { AuthApi } from './user-apis/AuthApi';
import { CLApiPageApi } from './user-apis/CLApiPageApi';
import { CLCodeApi } from './user-apis/CLCodeApi';
import { CLCodeTypeApi } from './user-apis/CLCodeTypeApi';
import { CLEtcApi } from './user-apis/CLEtcApi';
import { CLJobApi } from './user-apis/CLJobApi';
import { CLMsgMngApi } from './user-apis/CLMsgMngApi';
import { CLNavApi } from './user-apis/CLNavApi';
import { CLPrivApi } from './user-apis/CLPrivApi';
import { CLRoleApi } from './user-apis/CLRoleApi';
import { CLRoleUserApi } from './user-apis/CLRoleUserApi';
import { CLSystemLogApi } from './user-apis/CLSystemLogApi';
import { GridApi } from './user-apis/GridApi';
import { LayoutApi } from './user-apis/LayoutApi';
import { LockApi } from './user-apis/LockApi';
import { PdsApi } from './user-apis/PdsApi';
import { ProfileApi } from './user-apis/ProfileApi';
import { TeamApi } from './user-apis/TeamApi';
import { TmpMigApi } from './user-apis/TmpMigApi';
import { UserApi } from './user-apis/UserApi';
import { UserManageApi } from './user-apis/UserManageApi';
import { MpMgmtEditApi } from './user-apis/MpMgmtEditApi';
import { ContractSalesApi } from './user-apis/ContractSalesApi';
import { CommonCodeApi } from './user-apis/CommonCodeApi';
import { MstBzppApi } from './user-apis/MstBzppApi';
import { MstMemberApi } from './user-apis/MstMemberApi';
import { ContractApi } from './user-apis/ContractApi';
import { MpMgmtApi } from './user-apis/MpMgmtApi';
import { MngStaffApi } from './user-apis/MngStaffApi';
import { MstIprmApi } from './user-apis/MstIprmApi';

export class UserMainApi {
  helper: ApiHelper;
  // begin clover framework apis
  clCode: CLCodeApi;
  clCodeType: CLCodeTypeApi;
  clJob: CLJobApi;
  clSystemLog: CLSystemLogApi;
  clEtc: CLEtcApi;
  clNav: CLNavApi;
  clPriv: CLPrivApi;
  clRole: CLRoleApi;
  clRoleUser: CLRoleUserApi;
  clPageApi: CLApiPageApi;
  clMsgMngApi: CLMsgMngApi;
  // end clover framework apis
  auth: AuthApi;
  pds: PdsApi;
  user: UserApi;
  userManage: UserManageApi;
  team: TeamApi;
  profile: ProfileApi;
  lock: LockApi;
  layout: LayoutApi;
  grid: GridApi;

  // User API Definitions
  tmpMig: TmpMigApi;
  MpEdt: MpMgmtEditApi;
  contractSales: ContractSalesApi;
  commonCode: CommonCodeApi;
  mstBzpp: MstBzppApi;
  mstMember: MstMemberApi;
  contract: ContractApi;
  mpMgmt: MpMgmtApi;
  mngStaff: MngStaffApi;
  mstIprm: MstIprmApi;

  constructor(
    public apiBaseURL: string,
    createApiHeader: () => Record<string, string>,
    responseInterceptor: ResponseInterceptor,
    errorResponseInterceptor: ErrorResponseInterceptor,
    debug = false,
  ) {
    log.debug('create Api for ', apiBaseURL);

    // create helper
    const helper = new ApiHelper(
      apiBaseURL,
      createApiHeader,

      responseInterceptor,
      errorResponseInterceptor,
      errorToMessage,
      debug,
    );

    this.helper = helper;

    // begin clover framework apis
    this.clCode = new CLCodeApi(helper);
    this.clCodeType = new CLCodeTypeApi(helper);
    this.clJob = new CLJobApi(helper);
    this.clSystemLog = new CLSystemLogApi(helper);
    this.clEtc = new CLEtcApi(helper);
    this.clNav = new CLNavApi(helper);
    this.clPriv = new CLPrivApi(helper);
    this.clRole = new CLRoleApi(helper);
    this.clRoleUser = new CLRoleUserApi(helper);
    this.clPageApi = new CLApiPageApi(helper);
    this.clMsgMngApi = new CLMsgMngApi(helper);
    // end clover framework apis

    this.auth = new AuthApi(helper);
    this.pds = new PdsApi(helper);
    this.user = new UserApi(helper);
    this.userManage = new UserManageApi(helper);
    this.team = new TeamApi(helper);
    this.profile = new ProfileApi(helper);
    this.lock = new LockApi(helper);
    this.layout = new LayoutApi(helper);
    this.grid = new GridApi(helper);
    this.tmpMig = new TmpMigApi(helper);
    this.MpEdt = new MpMgmtEditApi(helper);
    this.contractSales = new ContractSalesApi(helper);
    this.commonCode = new CommonCodeApi(helper);
    this.mstBzpp = new MstBzppApi(helper);
    this.mstMember = new MstMemberApi(helper);
    this.contract = new ContractApi(helper);
    this.mpMgmt = new MpMgmtApi(helper);
    this.mngStaff = new MngStaffApi(helper);
    this.mstIprm = new MstIprmApi(helper);
  }
}
